import CustomLinkButton from "./custom-link-button";

const ProjectCard = ({id, title, subtitle, description, image, links}) => {
    return (
        <div class="flex flex-col justify-between overflow-hidden rounded-3xl bg-base-100 shadow-2xl">
            <img alt={`Slide ${id}`} src={image} class="h-48 md:h-60 w-full object-cover" />

            <div class="px-4 md:px-8 pt-4">
                <p class="text-2xl font-bold">{title}</p>
                <p class="opacity-60">{subtitle}</p>
                <p class="text-sm font-medium mt-4">{description}</p>
            </div>

            <div class="flex justify-end gap-x-2 p-3 md:p-6">
                {links && links.map((link, index) => (
                        <CustomLinkButton key={index} style_classes={"custom-secondary-white-btn !h-11 !w-11 md:!h-12 md:!w-12"} size={link.size} link={link.link} path={link.path} />
                    ))}
            </div>
        </div>
    )
}

export default ProjectCard;